import { object, preprocess, string, TypeOf } from "zod";
import { isValidCpf, maskRemove } from "../../../../../services/UtilsService";

const associateSchema = object({
  name: string().nonempty("Nome é obrigatório"),
  email: string()
    .nonempty("Email é obrigatório")
    .email("Formato de e-mail inválido"),
  rg: preprocess((rg) => maskRemove(rg), string().nonempty("RG é obrigatório")),
  cpf: string()
    .nonempty("CPF é obrigatório")
    .refine((value) => isValidCpf(value.replace(/\D/g, "")), {
      message: "CPF inválido",
    }),
  mobilePhone: string()
    .nonempty("Celular é obrigatório")
    .refine(
      (value) =>
        value.replace(/\D/g, "").length === 10 ||
        value.replace(/\D/g, "").length === 11,
      {
        message: "Informe um telefone válido com DDD",
      }
    ),
  relationshipType: string().nonempty("Tipo de Sócio é obrigatório"),
  zipCode: string().nonempty("CEP é obrigatório"),
  address: string().nonempty("Logradouro é obrigatório"),
  neighborhood: string().nonempty("Bairro é obrigatório"),
  state: string().nonempty("Estado é obrigatório"),
  city: string().nonempty("Cidade é obrigatório"),
  number: string().nonempty("Número é obrigatório"),
  additionalInfo: string().transform((value) =>
    value === "" ? undefined : value
  ),
});

type AssociateInput = TypeOf<typeof associateSchema>;

export type { AssociateInput };

export { associateSchema };
